
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30921',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30921",
  "emoji-mart": "static-3.6",
  "feedback-schema": "static-1.55494",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8447",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11900",
  "I18n": "static-7.1691",
  "quartz": "static-1.7580",
  "quartz-config": "static-1.1358",
  "quartz-core": "static-1.6799",
  "react-dlb": "static-1.92",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.83",
  "reselect": "static-3.15",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.1029",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55481",
  "feedback-utils": "static-1.55485",
  "forms-embed-utils-lib": "static-1.4874",
  "forms-utils-lib": "static-1.13238",
  "foundations-assets": "static-1.5295",
  "foundations-components": "static-1.8646",
  "foundations-theming": "static-1.4887",
  "hub-http": "static-1.6618",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12207",
  "icons": "static-2.699",
  "immutable": "static-2.88",
  "quick-fetch": "static-1.4189",
  "raven": "static-3.5925",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17141",
  "react-select-plus": "static-1.116",
  "react-utils": "static-2.5620",
  "react-virtualized": "static-2.110",
  "redux": "static-4.81",
  "StyleGuideUI": "static-3.512",
  "tinymce-plugins": "static-1.58398",
  "transmute": "static-2.97",
  "ui-images": "static-2.1269",
  "UIComponents": "static-3.8846",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3857",
  "quartz-webpack": "static-1.3804",
  "foundations-theming-specialty": "static-1.2603",
  "property-description-translator": "static-1.4230",
  "HeadJS": "static-2.811",
  "framer-motion": "static-1.82",
  "hs-test-utils-bend-plugin": "static-1.3558",
  "msw": "static-1.39",
  "msw-config": "static-1.16",
  "testing-library": "static-1.162",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4717",
  "jasmine-runner": "static-1.6856",
  "opentelemetry-fe-types": "static-1.193",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.896",
  "hubspotter-http": "static-1.4924",
  "mobile-manifest-mixins": "static-1.593",
  "module-federation": "static-1.36",
  "opentelemetry-fe": "static-1.568",
  "quartz-auth": "static-1.1255",
  "quartz-head": "static-1.1245",
  "quartz-i18n": "static-1.1255",
  "quartz-routing": "static-1.1010",
  "quartz-test": "static-1.1255",
  "quartz-tracking": "static-1.959",
  "trellis-components": "static-1.2948",
  "ui-fonts": "static-1.1162",
  "usage-tracker-container": "static-1.7712",
  "usage-tracker-core": "static-1.7572",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.297",
  "conversations-skeleton-state": "static-1.7602",
  "reference-resolvers": "static-1.8589",
  "sanitize-text": "static-1.8566",
  "PatternValidationJS": "static-1.3296",
  "ReduxMessenger": "static-2.10779",
  "outpost": "static-1.4543",
  "rpc-client-utils": "static-1.5076",
  "sanitize": "static-1.4880",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4915",
  "floating-ui": "static-1.66",
  "hs-story-utils": "static-1.9834",
  "react-aria": "static-1.75",
  "react-create-root-preference": "static-1.88",
  "tanstack-table": "static-1.64",
  "trellis-assets": "static-1.2929",
  "bend-plugin-foundations-theming": "static-1.3370",
  "foundations-theming-base": "static-1.3872",
  "stylex": "static-1.45",
  "hs-locale-management": "static-1.358",
  "csstype": "static-1.50",
  "web-vitals": "static-1.18",
  "ai-components-ui-library": "static-1.9911",
  "atom": "static-1.5486",
  "codemirror": "static-5.105",
  "content-assistance-lib": "static-1.8333",
  "ContentUtils": "static-1.69330",
  "data-token-picker": "static-1.17033",
  "file-manager-components": "static-1.24727",
  "FileManagerCore": "static-1.40226",
  "FileManagerLib": "static-1.40367",
  "frontend-preferences-client": "static-1.8327",
  "hub-http-contrib": "static-1.3435",
  "interframe": "static-3.5150",
  "layout-dnd-components": "static-1.13118",
  "layout-dnd-utils": "static-1.12093",
  "property-translator": "static-1.5789",
  "react-codemirror": "static-1.11048",
  "react-colorpicker": "static-2.10620",
  "reference-resolvers-lite": "static-1.8513",
  "rich-text-lib": "static-1.20457",
  "tinymce-data": "static-1.41369",
  "tinymce-themes": "static-1.57254",
  "ui-addon-emoji-picker": "static-1.10276",
  "ui-addon-sales-email": "static-1.5612",
  "ui-brand-identity-lib": "static-1.16775",
  "bender-build-tools": "static-1.3472",
  "opentelemetry-web": "static-1.18",
  "beacon-keepalive-queue": "static-1.109",
  "hub-http-shared-msw-handlers": "static-1.10789",
  "hubspotter-http-shared-msw-handlers": "static-1.10787",
  "usage-tracker-session-replay": "static-1.5408",
  "base-ui": "static-1.25",
  "react-day-picker": "static-1.13",
  "trellis-theming": "static-1.1389",
  "tanstack-virtual": "static-1.41",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.486",
  "chirp-fetch": "static-1.2308",
  "stylex-utils": "static-1.158",
  "chatspot-core": "static-1.23467",
  "copilot-toolkit": "static-1.12031",
  "customer-data-objects-ui-components": "static-1.13438",
  "data-fetching-client": "static-1.10055",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5167",
  "ui-addon-video-player": "static-1.9057",
  "ui-coaching-tips": "static-1.29493",
  "usage-tracker": "static-1.7722",
  "cms-field-types": "static-1.5221",
  "content-icons-ui": "static-1.2417",
  "integrations-lib": "static-1.17288",
  "customer-data-objects": "static-1.8101",
  "apollo-dlb": "static-3.98",
  "breeze-engine-lib": "static-1.1993",
  "apollo-link-hub-http": "static-2.5019",
  "apollo-stack-hubspot": "static-3.97",
  "graphql": "static-1.92",
  "immer": "static-1.104",
  "immerable": "static-1.4551",
  "poll-commands": "static-1.3881",
  "ui-addon-iframeable": "static-1.9487",
  "video-components-external": "static-1.12317",
  "video-data-lib": "static-1.35975",
  "breeze-artifacts-sdk": "static-1.656",
  "audio-components": "static-1.6481",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29962",
  "FileManagerImages": "static-1.37878",
  "foundations-components-legacy": "static-1.1671",
  "html-to-image": "static-1.64",
  "redux-toolkit": "static-1.81",
  "salesImages": "static-1.667",
  "ui-universal-auth": "static-1.9608",
  "urlinator": "static-1.4924",
  "video-components": "static-1.14319",
  "video-embed": "static-1.36809",
  "ts-schema": "static-1.4358",
  "ContentData": "static-1.69405",
  "layout-data-lib": "static-1.10418",
  "react-dnd-compat": "static-1.5020",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1954",
  "external-options-client-types": "static-1.4406",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7304",
  "hs-promise-utils": "static-1.5998",
  "inbound-db-properties-service-client": "static-1.4106",
  "NamespacedHubStyle": "static-2.9323",
  "growth-onboarding-confetti": "static-1.3472",
  "SharedI18nStrings": "static-1.186",
  "ui-addon-i18n": "static-1.11555",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5845",
  "magpie-types": "static-1.5305",
  "simple-logging-lib": "static-1.3461",
  "avatar-components": "static-1.2892",
  "customer-data-ui-utilities": "static-1.10240",
  "growth-onboarding-feedback-components": "static-1.6992",
  "flux-actions": "static-1.378",
  "hubspot-apollo-client": "static-1.5283",
  "integrations-error-boundary-lib": "static-1.14703",
  "integrations-tracking-lib": "static-1.6019",
  "laboratory-lib": "static-3.7559",
  "native-integrations-shared-strings": "static-1.8171",
  "redux-observable": "static-1.78",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10682",
  "unified-auth": "static-1.1122",
  "breeze-engine-chat-components": "static-1.971",
  "breeze-engine-core": "static-1.1271",
  "ably": "static-2.2",
  "highlight.js": "static-1.89",
  "pulse": "static-1.1047",
  "navigation-messaging": "static-1.8370",
  "content-media-composition-data-lib": "static-1.13462",
  "content-media-compositions": "static-2.17469",
  "idb-keyval": "static-1.54",
  "media-bridge-lib": "static-1.19547",
  "nudge-client-utils": "static-1.3304",
  "unified-auth-core-lib": "static-1.1404",
  "social-insights-client-types": "static-1.22821",
  "advanced-menus-core": "static-1.15717",
  "advanced-menus-lib": "static-1.12512",
  "ExportDialog": "static-6.10783",
  "ui-memberships-settings-lib": "static-1.35063",
  "conditional-properties-service-client": "static-1.4080",
  "crm-pipelines-api-client-types": "static-1.4411",
  "fdsr-migration-layer": "static-1.423",
  "framework-builder-read-service-client": "static-1.4286",
  "framework-data-schema-quick-fetch": "static-1.7209",
  "inbound-db-meta-service-client": "static-1.3738",
  "multi-currency-client-types": "static-1.3975",
  "persist-promise": "static-1.4111",
  "foundations-components-test-utils": "static-1.6129",
  "reactive-lib": "static-1.1131",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.742",
  "universal-page-editor-lib": "static-1.3419",
  "adobe-sign-auth-lib": "static-1.653",
  "ads-unified-auth-lib": "static-1.1743",
  "custom-vendor-connection-lib": "static-1.172",
  "google-sheets-integration-lib": "static-1.1216",
  "microsoft-drive-auth-lib": "static-1.380",
  "surveymonkey-integration-lib": "static-1.748",
  "slack-ui-library": "static-1.10806",
  "bend-plugin-pulse": "static-1.550",
  "event-emitter": "static-1.1368",
  "fast-json-patch": "static-1.73",
  "js-cookie": "static-1.18",
  "nudge-custom-function-registry": "static-1.3061",
  "nudge-renderer-utils": "static-1.3380",
  "onboarding-tours": "static-1.17294",
  "whisper-core-api": "static-1.7520",
  "fsm": "static-1.4162",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15716",
  "simple-menus-lib": "static-1.17233",
  "settings-ui-lib": "static-1.12937",
  "crm-record-cards-service-types": "static-1.3834",
  "location-customization-utils-lib": "static-1.10304",
  "getting-started-shared-tasks": "static-1.19448",
  "growth-data-modal": "static-1.6038",
  "growth-onboarding-next-action-utils": "static-1.2874",
  "navigation-components": "static-1.19043",
  "onboarding-tours-client": "static-1.5509",
  "onboarding-tours-utils": "static-1.1361",
  "ui-shepherd-tracker": "static-1.8063",
  "user-context": "static-1.5476",
  "react-flip-move": "static-1.81",
  "onboarding-data-sync-lib": "static-1.2725",
  "growth-onboarding-next-action-components": "static-1.2902",
  "user-context-client": "static-1.4917",
  "nest": "static-1.644",
  "getting-started-shared-tasks-store": "static-1.18566",
  "InboxConnectUtils": "static-4.15735",
  "meetings-connect-utils-lib": "static-1.8024",
  "onboarding-scopes": "static-1.6860"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30921",
  "emoji-mart": "/emoji-mart/static-3.6",
  "feedback-schema": "/feedback-schema/static-1.55494",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8447",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11900",
  "I18n": "/I18n/static-7.1691",
  "quartz": "/quartz/static-1.7580",
  "quartz-config": "/quartz-config/static-1.1358",
  "quartz-core": "/quartz-core/static-1.6799",
  "react-dlb": "/react-dlb/static-1.92",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.83",
  "reselect": "/reselect/static-3.15",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.1029",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55481",
  "feedback-utils": "/feedback-utils/static-1.55485",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4874",
  "forms-utils-lib": "/forms-utils-lib/static-1.13238",
  "foundations-assets": "/foundations-assets/static-1.5295",
  "foundations-components": "/foundations-components/static-1.8646",
  "foundations-theming": "/foundations-theming/static-1.4887",
  "hub-http": "/hub-http/static-1.6618",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12207",
  "icons": "/icons/static-2.699",
  "immutable": "/immutable/static-2.88",
  "quick-fetch": "/quick-fetch/static-1.4189",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17141",
  "react-select-plus": "/react-select-plus/static-1.116",
  "react-utils": "/react-utils/static-2.5620",
  "react-virtualized": "/react-virtualized/static-2.110",
  "redux": "/redux/static-4.81",
  "StyleGuideUI": "/StyleGuideUI/static-3.512",
  "tinymce-plugins": "/tinymce-plugins/static-1.58398",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1269",
  "UIComponents": "/UIComponents/static-3.8846",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3857",
  "quartz-webpack": "/quartz-webpack/static-1.3804",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2603",
  "property-description-translator": "/property-description-translator/static-1.4230",
  "HeadJS": "/HeadJS/static-2.811",
  "framer-motion": "/framer-motion/static-1.82",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3558",
  "msw": "/msw/static-1.39",
  "msw-config": "/msw-config/static-1.16",
  "testing-library": "/testing-library/static-1.162",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4717",
  "jasmine-runner": "/jasmine-runner/static-1.6856",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.193",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.896",
  "hubspotter-http": "/hubspotter-http/static-1.4924",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.593",
  "module-federation": "/module-federation/static-1.36",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.568",
  "quartz-auth": "/quartz-auth/static-1.1255",
  "quartz-head": "/quartz-head/static-1.1245",
  "quartz-i18n": "/quartz-i18n/static-1.1255",
  "quartz-routing": "/quartz-routing/static-1.1010",
  "quartz-test": "/quartz-test/static-1.1255",
  "quartz-tracking": "/quartz-tracking/static-1.959",
  "trellis-components": "/trellis-components/static-1.2948",
  "ui-fonts": "/ui-fonts/static-1.1162",
  "usage-tracker-container": "/usage-tracker-container/static-1.7712",
  "usage-tracker-core": "/usage-tracker-core/static-1.7572",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.297",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "reference-resolvers": "/reference-resolvers/static-1.8589",
  "sanitize-text": "/sanitize-text/static-1.8566",
  "PatternValidationJS": "/PatternValidationJS/static-1.3296",
  "ReduxMessenger": "/ReduxMessenger/static-2.10779",
  "outpost": "/outpost/static-1.4543",
  "rpc-client-utils": "/rpc-client-utils/static-1.5076",
  "sanitize": "/sanitize/static-1.4880",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4915",
  "floating-ui": "/floating-ui/static-1.66",
  "hs-story-utils": "/hs-story-utils/static-1.9834",
  "react-aria": "/react-aria/static-1.75",
  "react-create-root-preference": "/react-create-root-preference/static-1.88",
  "tanstack-table": "/tanstack-table/static-1.64",
  "trellis-assets": "/trellis-assets/static-1.2929",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3370",
  "foundations-theming-base": "/foundations-theming-base/static-1.3872",
  "stylex": "/stylex/static-1.45",
  "hs-locale-management": "/hs-locale-management/static-1.358",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.18",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9911",
  "atom": "/atom/static-1.5486",
  "codemirror": "/codemirror/static-5.105",
  "content-assistance-lib": "/content-assistance-lib/static-1.8333",
  "ContentUtils": "/ContentUtils/static-1.69330",
  "data-token-picker": "/data-token-picker/static-1.17033",
  "file-manager-components": "/file-manager-components/static-1.24727",
  "FileManagerCore": "/FileManagerCore/static-1.40226",
  "FileManagerLib": "/FileManagerLib/static-1.40367",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8327",
  "hub-http-contrib": "/hub-http-contrib/static-1.3435",
  "interframe": "/interframe/static-3.5150",
  "layout-dnd-components": "/layout-dnd-components/static-1.13118",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12093",
  "property-translator": "/property-translator/static-1.5789",
  "react-codemirror": "/react-codemirror/static-1.11048",
  "react-colorpicker": "/react-colorpicker/static-2.10620",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8513",
  "rich-text-lib": "/rich-text-lib/static-1.20457",
  "tinymce-data": "/tinymce-data/static-1.41369",
  "tinymce-themes": "/tinymce-themes/static-1.57254",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10276",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5612",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16775",
  "bender-build-tools": "/bender-build-tools/static-1.3472",
  "opentelemetry-web": "/opentelemetry-web/static-1.18",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.109",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10789",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10787",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5408",
  "base-ui": "/base-ui/static-1.25",
  "react-day-picker": "/react-day-picker/static-1.13",
  "trellis-theming": "/trellis-theming/static-1.1389",
  "tanstack-virtual": "/tanstack-virtual/static-1.41",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.486",
  "chirp-fetch": "/chirp-fetch/static-1.2308",
  "stylex-utils": "/stylex-utils/static-1.158",
  "chatspot-core": "/chatspot-core/static-1.23467",
  "copilot-toolkit": "/copilot-toolkit/static-1.12031",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13438",
  "data-fetching-client": "/data-fetching-client/static-1.10055",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5167",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29493",
  "usage-tracker": "/usage-tracker/static-1.7722",
  "cms-field-types": "/cms-field-types/static-1.5221",
  "content-icons-ui": "/content-icons-ui/static-1.2417",
  "integrations-lib": "/integrations-lib/static-1.17288",
  "customer-data-objects": "/customer-data-objects/static-1.8101",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1993",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5019",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.97",
  "graphql": "/graphql/static-1.92",
  "immer": "/immer/static-1.104",
  "immerable": "/immerable/static-1.4551",
  "poll-commands": "/poll-commands/static-1.3881",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9487",
  "video-components-external": "/video-components-external/static-1.12317",
  "video-data-lib": "/video-data-lib/static-1.35975",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.656",
  "audio-components": "/audio-components/static-1.6481",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29962",
  "FileManagerImages": "/FileManagerImages/static-1.37878",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1671",
  "html-to-image": "/html-to-image/static-1.64",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "salesImages": "/salesImages/static-1.667",
  "ui-universal-auth": "/ui-universal-auth/static-1.9608",
  "urlinator": "/urlinator/static-1.4924",
  "video-components": "/video-components/static-1.14319",
  "video-embed": "/video-embed/static-1.36809",
  "ts-schema": "/ts-schema/static-1.4358",
  "ContentData": "/ContentData/static-1.69405",
  "layout-data-lib": "/layout-data-lib/static-1.10418",
  "react-dnd-compat": "/react-dnd-compat/static-1.5020",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1954",
  "external-options-client-types": "/external-options-client-types/static-1.4406",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7304",
  "hs-promise-utils": "/hs-promise-utils/static-1.5998",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4106",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9323",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3472",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11555",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5845",
  "magpie-types": "/magpie-types/static-1.5305",
  "simple-logging-lib": "/simple-logging-lib/static-1.3461",
  "avatar-components": "/avatar-components/static-1.2892",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10240",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6992",
  "flux-actions": "/flux-actions/static-1.378",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5283",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14703",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6019",
  "laboratory-lib": "/laboratory-lib/static-3.7559",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8171",
  "redux-observable": "/redux-observable/static-1.78",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10682",
  "unified-auth": "/unified-auth/static-1.1122",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.971",
  "breeze-engine-core": "/breeze-engine-core/static-1.1271",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.89",
  "pulse": "/pulse/static-1.1047",
  "navigation-messaging": "/navigation-messaging/static-1.8370",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13462",
  "content-media-compositions": "/content-media-compositions/static-2.17469",
  "idb-keyval": "/idb-keyval/static-1.54",
  "media-bridge-lib": "/media-bridge-lib/static-1.19547",
  "nudge-client-utils": "/nudge-client-utils/static-1.3304",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1404",
  "social-insights-client-types": "/social-insights-client-types/static-1.22821",
  "advanced-menus-core": "/advanced-menus-core/static-1.15717",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12512",
  "ExportDialog": "/ExportDialog/static-6.10783",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35063",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4080",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4411",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.423",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4286",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7209",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3738",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3975",
  "persist-promise": "/persist-promise/static-1.4111",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6129",
  "reactive-lib": "/reactive-lib/static-1.1131",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.742",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3419",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.653",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1743",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.172",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1216",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.380",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.748",
  "slack-ui-library": "/slack-ui-library/static-1.10806",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.550",
  "event-emitter": "/event-emitter/static-1.1368",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "js-cookie": "/js-cookie/static-1.18",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3061",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3380",
  "onboarding-tours": "/onboarding-tours/static-1.17294",
  "whisper-core-api": "/whisper-core-api/static-1.7520",
  "fsm": "/fsm/static-1.4162",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15716",
  "simple-menus-lib": "/simple-menus-lib/static-1.17233",
  "settings-ui-lib": "/settings-ui-lib/static-1.12937",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3834",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10304",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19448",
  "growth-data-modal": "/growth-data-modal/static-1.6038",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2874",
  "navigation-components": "/navigation-components/static-1.19043",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5509",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1361",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8063",
  "user-context": "/user-context/static-1.5476",
  "react-flip-move": "/react-flip-move/static-1.81",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2725",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2902",
  "user-context-client": "/user-context-client/static-1.4917",
  "nest": "/nest/static-1.644",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18566",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15735",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8024",
  "onboarding-scopes": "/onboarding-scopes/static-1.6860"
}
};
